/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CashFlowLedgerItem = {
  id?: number | null;
  readonly cap_table?: number;
  date_of_transaction: string;
  amount?: string | null;
  readonly currency?: string;
  transaction_type: string;
  /**
   * Designation for aggregation: invested capital vs proceeds. NULL = unclassified (falls back to sign of amount).
   */
  cash_flow_type?: CashFlowLedgerItem.cash_flow_type | null;
  owner_company?: number | null;
  owner_fund?: number | null;
  entity_company?: number | null;
  entity_alias?: number | null;
  security?: number | null;
  readonly is_virtual?: string;
  /**
   * If True, this item is visible on the Cash Flow Ledger UI but excluded from IRR / MOIC / realized value / invested capital aggregations everywhere.
   */
  is_excluded_from_calculations?: boolean;
  /**
   * ID from external system to correlate with (e.g. iLevel cash_transaction)
   */
  external_id?: string | null;
  cell_annotations?: Record<string, Record<string, {
    row_mode?: 'single_cell' | 'single_row' | 'multi_row';
    columns_config?: Array<any>;
    rows?: Array<{
      position?: number;
      value?: string | null;
      metadata?: any;
    }>;
  }>>;
};
export namespace CashFlowLedgerItem {
  /**
   * Designation for aggregation: invested capital vs proceeds. NULL = unclassified (falls back to sign of amount).
   */
  export enum cash_flow_type {
    INVESTED_CAPITAL = 'invested_capital',
    PROCEEDS = 'proceeds',
  }
}

